export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target, ...sources) {
  if (!sources.length) {
    return target;
  }

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }

        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function getRealUrl(url: string, parameters: any = {}) {
  for (let key of Object.keys(parameters)) {
    url = url.replace('${' + key + '}', parameters[key]);
  }

  return url;
}

export function clone<T>(obj: T): T {
  if (!!obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  return obj;
}

export function isEmptyArray(value) {
  return value === undefined || value === null || value.length === 0;
}

export function isNullOrUndefined(value) {
  return value === undefined || value === null;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/server/src/utils/object.extensions.ts